import { processComponentOption, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_017e6569";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_017e6569" };
/** script content **/
require("./loading.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex017e6569%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Floading%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_017e6569"],
    ctorType: "component",
    outputPath: "components/index017e6569/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
